import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import ImageUploading from "react-images-uploading";
import Global from "../util/Global";
import { AlertContext } from "../util/Alerter";


export default function ImageUploader({ error, images, maxImages, setImages, setisLoading, onImageDelete }) {
    const { t } = useTranslation()
    const { showAlert } = useContext(AlertContext)


    async function fetchDeleteAllImages() {
        setisLoading(true)
        const deletePromises = images.map((image, index) => {
            if (image.imageURL) {
                return onImageDelete(image.id).then(() => index).catch((err) => { })
            }
            return Promise.resolve(index);
        });

        try {
            const indicesToRemove = await Promise.all(deletePromises);
            const newImages = images.filter((_, index) => !indicesToRemove.includes(index));
            setImages(newImages);
            setisLoading(false)
        } catch (err) {
            showAlert("error", t("request.errorDeleteImage"));
        }
    }



    return (
        <ImageUploading
            multiple
            value={images}
            onChange={setImages}
            maxNumber={maxImages}
            dataURLKey="data_url"
        >
            {({
                imageList,
                onImageUpload,
                onImageRemoveAll,
                onImageUpdate,
                onImageRemove,
                isDragging,
                dragProps,
            }) => (
                <>
                    <div className="row">
                        <div
                            className="upload__image-wrapper dropzone d-flex justify-content-center align-items-center text-center"
                            onClick={onImageUpload}
                            {...dragProps}
                            style={{ cursor: "pointer", border: error ? "2px dashed red" : "" }}
                        >
                            <div className="dz-message needsclick">
                                <div className="mb-3">
                                    <i className="display-4 text-muted mdi mdi-cloud-download-outline"></i>
                                </div>

                                <h4>{t("uploadImage")}</h4>
                            </div>
                        </div>



                        {imageList.length !== 0 && (
                            <button
                                className="btn btn-danger"
                                onClick={() => {
                                    fetchDeleteAllImages()
                                    onImageRemoveAll()
                                }}
                            >
                                {t("deleteallImages")}
                            </button>
                        )}

                        <div className="container text-center w-100 p-3">
                            <div className="row">
                                {imageList.map((image, index) => (
                                    <div className="col-md-2" key={index}>
                                        <div
                                            className="image-item"
                                            style={{
                                                width: 120,
                                                height: 120,
                                                paddingTop: 10,
                                                position: "relative",
                                            }}
                                        >
                                            <i
                                                className="mdi mdi-progress-close"
                                                style={{
                                                    color: "red",
                                                    fontSize: 25,
                                                    position: "absolute",
                                                    right: -12,
                                                    top: -11,
                                                    cursor: "pointer",
                                                }}
                                                onClick={() => {
                                                    if (image.imageURL) {
                                                        setisLoading(true)
                                                        onImageDelete(image.id).then(() => {
                                                            const newImages = images.filter((_, i) => i !== index);
                                                            setImages(newImages);
                                                        }).catch((err) => {

                                                        }).finally(() => {
                                                            setisLoading(false)
                                                        })
                                                    } else {
                                                        onImageRemove(index);
                                                    }
                                                }
                                                }
                                            ></i>
                                            <div className="shake-admin">
                                                <img
                                                    className="image-admin-shake"
                                                    style={{
                                                        borderRadius: 15,
                                                        width: 100,
                                                        height: 100,
                                                        border: "1px solid red",
                                                    }}
                                                    src={image.imageURL ? `${Global.backend}/uploads/${image.imageURL}` : image["data_url"]}
                                                    alt=""
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))}

                            </div>
                        </div>
                    </div>
                </>
            )}
        </ImageUploading>

    )
}